import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewObsExtensionAdded } = appStoreLenses

export default viewObsExtensionAdded
